import { taskApi as api } from './api';
import axios from 'axios';

export interface SearchProjectParams {
  name?: string;
  projectIds?: string[];
  participatingProjectsOnly?: boolean;
}

export interface AvailableProject {
  id: string;
  name: string;
  displayId: string;
}

export interface FetchAvailableProjectResponse {
  availableProjects: AvailableProject[];
}

export const searchProjects = async ({
  name,
  projectIds,
  participatingProjectsOnly = false,
}: SearchProjectParams) => {
  let url = `/v2/available-projects/`;
  const urlParams = new URLSearchParams();
  if (name) {
    urlParams.append('name', name);
  }

  if (projectIds) {
    projectIds.forEach((id) => urlParams.append('projectIds[]', id));
  }

  url = `${url}?${urlParams.toString()}`;

  const config = {
    headers: {
      'participating-projects-only': participatingProjectsOnly
        ? 'true'
        : 'false',
    },
  };

  const response = await api.get<FetchAvailableProjectResponse>(url, config);
  if (axios.isAxiosError(response)) {
    throw response;
  }
  return response.data;
};
